import { render, staticRenderFns } from "./DashboardMonthlyOrders.vue?vue&type=template&id=350a274e&scoped=true&"
import script from "./DashboardMonthlyOrders.vue?vue&type=script&lang=js&"
export * from "./DashboardMonthlyOrders.vue?vue&type=script&lang=js&"
import style0 from "./DashboardMonthlyOrders.vue?vue&type=style&index=0&id=350a274e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350a274e",
  null
  
)

export default component.exports